import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Routes } from "../../../configurations/config";

const LeaveActionComponent = ({ leaveApplicationId, supervisorStatus }) => {
	return (
		<div>
			<Link
				to={{
					pathname: `${Routes.LeaveDetail}/${leaveApplicationId}`,
					state: {
						status: supervisorStatus,
					},
				}}
			>
				<button className="btnStyle" title="View Detail">
					<FontAwesomeIcon
						id="edit"
						className="hoverEffect"
						icon={faEye}
						size="1x"
					/>
				</button>
			</Link>
		</div>
	);
};

export default LeaveActionComponent;
